import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { Vacations } from '../../onboarding/classes/vacations';

@Injectable()
export class VacationsService {

  constructor(private http: Http) { }

  addVacation(orgId: number, info: Vacations) {
    let data = { vacation: info, commit: 'Complete', organization_id: orgId };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.post(`${environment.organizationsUrl}${orgId}/${environment.vacationsUrl}`, data, options)
      .map(res => res.json())
  }

  editVacation(orgId: number, id: number, info: Vacations) {
    let data = { vacation: info, commit: 'Complete', organization_id: orgId, id };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.patch(`${environment.organizationsUrl}${orgId}/vacations/${id}.json`, data, options)
      .map(res => res.json())
  }

  getVacations(orgId: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.get(`${environment.organizationsUrl}${orgId}/${environment.vacationsUrl}`, options)
      .map(res => res.json())
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/services/vacations.service.ts